/**
 * Scroll window and any overflow ancestors to the top.
 * Needed for Liferay-embedded SPAs where MemoryRouter keeps prior scroll,
 * and scroll often lives on a parent (not only window).
 */
export function scrollToTop({ behavior = "auto" } = {}) {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  const scrollElement = (el) => {
    if (!el) return;
    try {
      if (typeof el.scrollTo === "function") {
        el.scrollTo({ top: 0, left: 0, behavior });
      } else {
        el.scrollTop = 0;
        el.scrollLeft = 0;
      }
    } catch {
      try {
        el.scrollTop = 0;
        el.scrollLeft = 0;
      } catch {
        // ignore non-scrollable nodes
      }
    }
  };

  scrollElement(window);
  scrollElement(document.scrollingElement);
  scrollElement(document.documentElement);
  scrollElement(document.body);

  const marked = document.querySelectorAll(
    "[data-scroll-container], .portlet-body, #wrapper, #content, #main-content, .insurance-journey-summary, .plan-and-summary-section",
  );
  marked.forEach(scrollElement);

  const anchor =
    document.querySelector(".insurance-journey-summary") ||
    document.querySelector(".plan-and-summary-section");
  let parent = anchor?.parentElement ?? null;
  while (parent && parent !== document.documentElement) {
    try {
      const style = window.getComputedStyle(parent);
      const overflowY = style?.overflowY;
      if (
        (overflowY === "auto" ||
          overflowY === "scroll" ||
          overflowY === "overlay") &&
        parent.scrollHeight > parent.clientHeight
      ) {
        scrollElement(parent);
      }
    } catch {
      // ignore
    }
    parent = parent.parentElement;
  }
}

/** Scroll now and again after paint (layout/async content). */
export function scrollToTopOnMount() {
  scrollToTop();
  if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
    window.requestAnimationFrame(() => {
      scrollToTop();
      window.setTimeout(() => scrollToTop(), 0);
    });
  }
}
